import {
  REMOVE_AGENT_START,
  REMOVE_AGENT_SUCCESS,
  REMOVE_AGENT_ERROR,
} from 'constants/action-types/projects/removeAgent';

export default (state, { type, payload }) => {
  switch (type) {
    case REMOVE_AGENT_START:
      return {
        ...state,
        removeAgent: {
          ...state.removeAgent,
          loading: true,
          error: null,
          message: null,
        },
      };
    case REMOVE_AGENT_SUCCESS:
      return {
        ...state,
        removeAgent: {
          ...state.removeAgent,
          message: payload,
          error: null,
          loading: false,
        },
      };
    case REMOVE_AGENT_ERROR:
      return {
        ...state,
        removeAgent: {
          ...state.removeAgent,
          loading: false,
          error: payload,
          message: null,
        },
      };
    default:
      return null;
  }
};
